import createEntityRepository from "./basicEntity";
const normalizeCountryPayload = (payload) => ({
    name: payload.name,
    activeStatus: payload.activeStatus,
    phoneNumberFormat: payload.phoneNumberFormat,
});
export default (repositoryInstance, utils) => createEntityRepository({
    repositoryInstance,
    utils,
    normalizeEntityPayload: normalizeCountryPayload,
    basePath: "countries",
});
//# sourceMappingURL=country.js.map